module.exports = __webpack_public_path__ + "static/media/padaria.6320f7d7.jpg";